module.exports = __webpack_public_path__ + "static/img/logo2.5cc6ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brief/logo2.png
// module id = ifYT
// module chunks = 1